import { useCallback } from 'react';
import { emit, on, off } from 'helpers/wsocket';


interface Transaction {
    address: {
        pair: string;
        timestamp: number;
        transactionHash: string;
        transactionType: 'buy' | 'sell' | string;
        walletAddress: string;
        baseTokenAmount: number;
        quoteTokenAmount: number;
        baseTokenPriceUsd: number;
        quoteTokenPriceUsd: number;
        baseQuotePrice: number;
        totalValueUsd: number;
    }
}

export const useRealtimeTrade = () => {

    const subscribePairTransaction = useCallback((pair_address: any) => {
        emit('subcribeLatestTransaction', btoa(JSON.stringify({ pool: pair_address })));
    }, []);

    const unsubscribePairTransaction = useCallback((pair_address: any) => {
        emit('unsubcribeLatestTransaction', btoa(JSON.stringify({ pool: pair_address })));
    }, []);

    const subscribeLatestTransaction = useCallback(
        (callback: (data: Transaction) => void) => {
            on('subcribeLatestTransaction', callback);
            // return () => {
            //     off('subcribeLatestTransaction', callback);
            // };
        },
        []
    );

    const unsubscribeLatestTransaction = useCallback(() => {
        off('subcribeLatestTransaction');
    }, []);

    return {
        subscribeLatestTransaction,
        unsubscribeLatestTransaction,
        subscribePairTransaction,
        unsubscribePairTransaction
    };
};